import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

// /////////////////////////////////////////////////////////////////////////////////////////////
// ApiUsers /////////////////////////////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////
class apiUsers {
  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUserGet(aUserId) {
    if (!aUserId || typeof aUserId !== 'string') {
      const errMsg = `apiUserGet: Invalid parameter [${aUserId}]`;
      console.warn(errMsg);
      return null;
    }
    return g_HttpReq.fetchGetJson('/users/' + encodeURIComponent(aUserId), {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUsersGet() {
    return g_HttpReq.fetchGetJson('/users', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUsersWithoutOrgGet() {
    return g_HttpReq.fetchGetJson('/users/no-org-users', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUserCreate(props = {}) {
    return g_HttpReq.fetchPostJson('/users', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUserUpdate(props = {}) {
    if (!props || typeof props !== 'object') {
      const errMsg = `Invalid parameter [${props}]`;
      console.warn(errMsg);
      return Promise.reject({ status: 400, statusText: errMsg });
    }
    const { entityId } = props;
    if (!entityId) {
      console.warn('Missing required parameter entityId');
      return Promise.reject({ status: 400, statusText: 'Missing required parameter entityId' });
    }

    return g_HttpReq.fetchPatchJson('/users/' + encodeURIComponent(entityId), props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUserDelete(aUserId) {
    if (!aUserId || typeof aUserId !== 'string') {
      const errMsg = `apiUserDelete: Invalid parameter [${aUserId}]`;
      console.warn(errMsg);
      return null;
    }
    return g_HttpReq.fetchDeleteJson('/users/' + encodeURIComponent(aUserId), null);
  }
}

const g_apiUsers = new apiUsers();
export default g_apiUsers;
